// react
import React, { useContext } from 'react';
import useForm from 'react-hook-form';
import { useTranslation } from 'react-i18next';

// material-ui icons

// material-ui components
import TextField from '@material-ui/core/TextField';
import FormHelperText from "@material-ui/core/FormHelperText";
import CircularProgress from '@material-ui/core/CircularProgress';

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";

// services
import {MaskMoney, transformValueFormatedtoFloat} from "beaktShared/helpers/masks";

// style
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/BeaktClinic/views/Venda/pagamentoDinheiro.js";
const useStyles = makeStyles(styles);

export default function PagamentoDinheiro({ pgto, CallloadTotalizadorPgtos }) {
  const { t } = useTranslation();
  const classes = useStyles();
  const {register, errors, handleSubmit, setValue} = useForm({mode: "onBlur"}); 
    
  const [messageReturn,setmessageReturn]= React.useState({
    show:false,
    message:''
  });

  const [LoadingForm,setLoadingForm]= React.useState(false);
  const onSubmit = (data, e) => {
    e.preventDefault();
    
    //console.log('Adicionar Dinheiro');    
    setLoadingForm(true);
    let valor = transformValueFormatedtoFloat(data.valor);
    if(valor > pgto.totalizadorPagamentos.valorPendente.toFixed(2))
    {
      setmessageReturn({
        show:true,
        message:t('error_message.the_amount_must_be_equal_or_less_than_the_balance_to_pay')
      });    
      setLoadingForm(false);  
      return false;
    }

    let pg = {
      id:pgto.pagamentos.length+1,
      tipo:0, //0- Dinheiro / 1-Cartão / 2-Boleto / 3-Cheque / 4-Outros
      descricaoFormaPgto: 'Dinheiro',
      valor:valor,
      descTipo: t('sale.money'),
      parcela:1,
      descPacela: t('label.at_sight')
    }

    let updatepgto ={
      ...pgto,        
      pagamentos:[
        ...pgto.pagamentos,
        pg
      ]
    };

    setValue("valor","");
    setmessageReturn({show:false})
    setLoadingForm(false);  
    CallloadTotalizadorPgtos(updatepgto);   
    return true;
  }
    
return (
    <div>    

      
      <form onSubmit={handleSubmit(onSubmit)}>                            
      <GridContainer className={classes.containerin}> 
        <GridItem xs={12} sm={3} md={3}>
          <div className={classes.labelIdent}>
            {t('label.value')} *
          </div>
        </GridItem>
        <GridItem xs={12} sm={6} md={6}>  
            <TextField
                fullWidth
                variant="outlined"
                InputLabelProps={{shrink: true}} 
                defaultValue=""  
                name="valor"               
                InputProps={{ inputComponent: MaskMoney}}    
                inputRef={register({required: true})}
                error={errors.valor?true:false} 
            />
            <FormHelperText>
                {errors.valor && <span className="obg">{t('label.required')}</span>}
            </FormHelperText>   
        </GridItem>
      </GridContainer>

     
      <GridContainer className={classes.containerin}>
        <GridItem xs={12} sm={12} md={12}>
            {messageReturn.show &&
            <div className="alertErrorEx alertmax">
                <p>
                {messageReturn.message}   
                </p>
            </div>
            }
            <br/>
            <center>
            <Button type="submit" color="primary" >
            {t('button.post_payment')}                    
            </Button>
            {LoadingForm && <CircularProgress />}
            </center>
        </GridItem>
      </GridContainer>
      </form>
    
    </div>
);
}